<template>
    <div class="z-10 flex flex-none h-32 group cursor-pointer"
        :class="first ? 'w-46' : '-ml-10 w-52'"
        :style="{ zIndex: 90 - order }"
        @click="select"
    >
        <div class="flex flex-1 items-end group-hover:bg-blue-100 border-b-4 py-2 pr-1 leading-tight text-xs uppercase font-semibold tracking-wide"
            :class="[ status_class, first ? 'pl-3' : 'pl-10' ]"
        >
            <p class="text-gray-600 group-hover:text-blue-700 focus:outline-none focus:shadow-none select-none">
                 {{ $t(label) }}
            </p>
        </div>

        <div class="group-hover:text-blue-100 w-10 -ml-px"
            :class="arrow_class"
        >
            <svg class="h-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.1 130.3">
                <polyline fill="currentColor" stroke="#afbfcf" points="0.4 0.2 33.6 65.1 0.4 130" />
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: {},
        status: {},
        order: {},
        first: { default: false, },
        id: {},
        focus_field: {},
        route: {},
    },

    computed: {
        status_class() {
            switch (this.status) {
                case 'red':
                    return 'bg-red-100 border-red-600';
                case 'yellow':
                    return 'bg-yellow-100 border-yellow-500';
                case 'green':
                    return 'bg-green-100 border-green-500';
                default:
                    return 'bg-white border-transparent';
            }
        },
        arrow_class() {
            switch (this.status) {
                case 'red':
                    return 'text-red-100';
                case 'yellow':
                    return 'text-yellow-100';
                case 'green':
                    return 'text-green-100';
                default:
                    return 'text-white';
            }
        },
    },

    methods: {
        select() {
            window.location.href = this.focus_field
                ? this.route + '/?field=' + this.focus_field
                : this.route;
        },
    },
}
</script>
